import React, { useState, useEffect } from "react";
import LandingPage from "./components/LandingPage/LandingPage";
import ProjectSection from "./components/ProjectSection/ProjectSection";
import ContactSection from "./components/ContactSection/ContactSection";
import { Particles } from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";

const App = () => {
  const [expandedProject, setExpandedProject] = useState(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.height = "100%";

    return () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    };
  }, []);

  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  const particlesConfig = {
    background: {
      opacity: 0,
    },
    particles: {
      number: {
        value: 70,
        density: {
          enable: true,
          value_area: 800,
        },
        limit: 80,
      },
      color: {
        value: "#ffffff",
      },
      links: {
        enable: true,
        distance: 150,
        color: "#ffffff",
        opacity: 0.4,
        width: 1,
      },
      move: {
        enable: true,
        speed: 2,
        direction: "none",
        random: false,
        straight: false,
        outModes: {
          default: "bounce",
        },
        attract: {
          enable: false,
          rotateX: 600,
          rotateY: 1200,
        },
      },
    },
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "grab",
        },
        onClick: {
          enable: true,
          mode: "push",
        },
      },
      modes: {
        grab: {
          distance: 140,
          links: {
            opacity: 1,
          },
        },
        push: {
          quantity: 4,
        },
      },
    },
    retina_detect: true,
    fps_limit: 60,
  };

  return (
    <HelmetProvider>
      <div className="app">
        <Particles
          id="tsparticles"
          init={particlesInit}
          options={particlesConfig}
          className="particles"
        />
        <LandingPage />
        <ProjectSection
          expandedProject={expandedProject}
          setExpandedProject={setExpandedProject}
        />
        <ContactSection />
      </div>
    </HelmetProvider>
  );
};

export default App;
